import React, { use, useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";

import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Loader from '../../components/loader';

function LedgerReport() {

    const location = useLocation();
    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(param);
    };

    const [orderData, setData] = useState([]);
    const today = new Date().toISOString().split('T')[0];
    const [eDate, setEDate] = useState(getQueryParam('eDate'));
    const [sDate, setSDate] = useState(getQueryParam('sDate'));
    const [loader, setLoader] = useState(false);

    const dealerId = getQueryParam('id');

    useEffect(()=> {
        getData();
    },[]);

    const formatDate = (date) => {     
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`;
        return formattedDate;
    };

    const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const month = newDate.toLocaleString('en-US', { month: 'short' }); // Jan, Feb, Mar...
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${month}-${newDate.getFullYear()}`;

        return formattedDate;
    };

    const formatSendDate = (dateStr) => {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    };

    const getFiscalYearLabel = (date = new Date()) => {
        const year = date.getFullYear();
        const month = date.getMonth(); 
        if (month < 3) {
          return `${(year-1).toString().slice(-2)}-${year.toString().slice(-2)}`;
        } else {
          return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
        }
    };

    const getData = async () => {
        setLoader(true);
        const sendData = {
            sDate: formatSendDate(sDate),
            eDate: formatSendDate(eDate),
            dealerId: dealerId
        };

        try {
            const response = await axios.post('https://api.trucoo.in/dealers/dealer-report/', sendData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });

            if (response.data.status === "success") {
                setData(response.data.data);
            } else {
                console.log("Error fetching data");
                setData([]); 
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
            setData([]); 
        }
        setLoader(false);
    };

    const getTotal = (data, type) => {

        if(type === 'milk'){
            let milk = 0;
            data?.forEach(item =>{
                if (item.itemType === "milk") {
                    milk += parseFloat(item.qty) * parseFloat(item.itemGrade) * parseFloat(item.itemWeight/1000);
                }
            });
            return milk;
        }

        if(type === 'curd'){
            let curd = 0;
            data?.forEach(item =>{
                if (item.itemType === "curd") {
                    curd += parseFloat(item.qty) * parseFloat(item.itemGrade) * parseFloat(item.itemWeight/1000);
                }
            });
            return curd;
        }

    };

    const exportToExcel = () => {
        const ws = XLSX.utils.table_to_sheet(document.getElementById('printableArea'));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Daily Sales Report');
        XLSX.writeFile(wb, `Dealers_Report_${formatDate(today)}.xlsx`);
    };

    let invoices = 0;
    let milk = 0;
    let curd = 0;
    let amount = 0;
    let discount = 0;

    return (
        <>
            {loader && <Loader /> }
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                
                                <div className="row" >
                                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12" >
                                        <h4 className="box-title">Dealers Report</h4>
                                        <p className="mb-0 box-subtitle">Invoices</p>
                                    </div>
                                   <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" >
                                        <input
                                            type="date"
                                            value={formatDate(sDate)}
                                            onChange={(e) => setSDate(e.target.value)}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" >
                                        <input
                                            type="date"
                                            value={formatDate(eDate)}
                                            onChange={(e) => setEDate(e.target.value)}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" >
                                        <button class="btn btn-sm btn-success" onClick={getData} >Get Report</button>
                                    </div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" align="right">
                                        <button className="btn btn-sm btn-warning" onClick={exportToExcel}><i className="fa fa-download"></i> Excel</button>
                                    </div>
                                </div>
                            </div>
                          
                            <div className="box-body">
                                <div className="table-responsive" style={{width: '100%', height: '65vh', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                                    <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-10" id="printableArea" width='100%'>
                                        <thead>
                                            <tr className="text-dark text-center" style={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                                <th width="2%">S.No</th>
                                                <th width="6%">Date</th>
                                                <th width="5%">Invoice ID</th>
                                                <th width="7%">Milk LTR</th>
                                                <th width="7%">Curd KG</th>
                                                <th width="7%">Net Total</th>
                                                <th width="7%">Discount</th>
                                                <th width="7%">Grand Total</th>
                                                <th width="5%">View</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orderData?.map((item, index) => {

                                                const totalAmount = parseFloat(item?.totalPayment);
                                                const totalMilk = getTotal(item?.orderDetails, 'milk');
                                                const totalCurd = getTotal(item?.orderDetails, 'curd');
                                                const totalDiscount = parseFloat(item?.discount);

                                                invoices += item?.length;
                                                milk += totalMilk;
                                                curd += totalCurd;
                                                amount += totalAmount;
                                                discount += totalDiscount;

                                                return (
                                                <tr key={index}>
                                                    <td className="text-center">{index + 1}</td>
                                                    <td data-t="s">{formatViewDate(item?.date)}</td>
                                                    <td>{`TRC/${item?.invoiceId}/${getFiscalYearLabel(new Date(item?.date))}`}</td>
                                                    <td className='text-end'>{Number(totalMilk) > 0 && Number(totalMilk).toFixed(2)}</td>
                                                    <td className='text-end'>{Number(totalCurd) > 0 && Number(totalCurd).toFixed(2)}</td>
                                                    <td className='text-end'>{Number(totalAmount) > 0 && Number(totalAmount).toFixed(2)}</td>
                                                    <td className='text-end'>{Number(totalDiscount) > 0 && Number(totalDiscount).toFixed(2)}</td>
                                                    <td className='text-end'>{Number(totalAmount) > 0 && Number(totalAmount - totalDiscount).toFixed(2)}</td>
                                                    <td className='text-center'>
                                                        <a href={`invoice-details?id=${item?.orderId}`} className="btn btn-sm btn-warning" >Invoice</a>
                                                    </td>
                                                </tr>
                                            )}
                                            )}
                                                <tr>
                                                    <th colspan="3">Total</th>
                                                    <th className='text-end'>{Number(milk).toFixed(2)}</th>
                                                    <th className='text-end'>{Number(curd).toFixed(2)}</th>
                                                    <th className='text-end'>{Number(amount).toFixed(2)}</th>
                                                    <th className='text-end'>{Number(discount).toFixed(2)}</th>
                                                    <th className='text-end'>{Number(amount - discount).toFixed(2)}</th>
                                                    <th></th>
                                                </tr>
                                       </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

        </>
    );
}

export default LedgerReport;